import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "text-gray-500" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded-lg bg-slate-700 h-[60px] w-[60px]\"></div><div class=\"flex-1 space-y-6 py-1\"><div class=\"h-2 bg-slate-700 rounded\"></div><div class=\"space-y-3\"><div class=\"grid grid-cols-3 gap-4\"><div class=\"h-2 bg-slate-700 rounded col-span-2\"></div><div class=\"h-2 bg-slate-700 rounded col-span-1\"></div></div><div class=\"h-2 bg-slate-700 rounded\"></div></div></div>", 2)
const _hoisted_6 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MusicPlayer = _resolveComponent("MusicPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_Input, {
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        modelModifiers: { lazy: true },
        placeholder: _ctx.$t('Title of music')
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.$t('The song you are looking for may be copyrighted and therefore not available')), 1),
      _createVNode(_component_Button, {
        onClick: _ctx.submit,
        "is-loading": _ctx.processing,
        class: "mt-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Search')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "is-loading"])
    ], 32),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.processing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "animate-pulse flex space-x-4 items-center p-3 rounded-lg bg-gray-900 my-2"
            }, _hoisted_6)
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.songs, (song) => {
            return (_openBlock(), _createElementBlock("div", {
              key: song,
              class: "w-full max-w-sm mx-auto py-1 px-2 rounded-lg my-1"
            }, [
              _createVNode(_component_MusicPlayer, {
                class: "mx-auto",
                music: song,
                post_created_at: song.date
              }, null, 8, ["music", "post_created_at"]),
              _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.$emit('onSelected', song))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Choose')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 128))
    ])
  ]))
}